export let SinglePlanWidgetRole = /*#__PURE__*/function (SinglePlanWidgetRole) {
  SinglePlanWidgetRole["MultiStateBox"] = "multiStateBox1";
  SinglePlanWidgetRole["StateLoaded"] = "planInfo";
  SinglePlanWidgetRole["StateSpinner"] = "loading";
  SinglePlanWidgetRole["StateEmpty"] = "empty";
  return SinglePlanWidgetRole;
}({});
export let PlanListWidgetRole = /*#__PURE__*/function (PlanListWidgetRole) {
  PlanListWidgetRole["PlanListWidget"] = "planListWidget";
  PlanListWidgetRole["PlanListStates"] = "planListStates";
  PlanListWidgetRole["LoadingState"] = "loading";
  PlanListWidgetRole["PlansInfoState"] = "plansInfo";
  PlanListWidgetRole["ErrorState"] = "error";
  PlanListWidgetRole["EmptyState"] = "empty";
  PlanListWidgetRole["Header"] = "header";
  PlanListWidgetRole["Title"] = "title";
  PlanListWidgetRole["TitleContainer"] = "titleContainer";
  PlanListWidgetRole["Subtitle"] = "subtitle";
  PlanListWidgetRole["SubtitleContainer"] = "subtitleContainer";
  PlanListWidgetRole["Disclaimer"] = "disclaimer";
  PlanListWidgetRole["DisclaimerContainer"] = "disclaimerContainer";
  PlanListWidgetRole["PlanList"] = "planList";
  PlanListWidgetRole["PlanListItemContainer"] = "planListItemContainer";
  PlanListWidgetRole["PlanListItem"] = "planListItem";
  PlanListWidgetRole["PlanVariantBox"] = "multiStateBox1";
  PlanListWidgetRole["PlanVariantDefaultState"] = "DefaultPlan";
  PlanListWidgetRole["PlanVariantHighlightedState"] = "HighlightedPlan";
  PlanListWidgetRole["PlanVariantCustomState"] = "CustomPlan";
  PlanListWidgetRole["PlanVariantDefaultWidget"] = "plan2";
  PlanListWidgetRole["PlanVariantHighlightedWidget"] = "plan5";
  PlanListWidgetRole["PlanVariantCustomWidget"] = "plan4";
  PlanListWidgetRole["EmptyStateTitle"] = "text6";
  PlanListWidgetRole["EmptyStateSubtitle"] = "text7";
  PlanListWidgetRole["ErrorStateTitle"] = "text4";
  PlanListWidgetRole["ErrorStateSubtitle"] = "text5";
  PlanListWidgetRole["ErrorStateButton"] = "button1";
  return PlanListWidgetRole;
}({});
export let PlanWidgetRole = /*#__PURE__*/function (PlanWidgetRole) {
  PlanWidgetRole["Image"] = "imageX1";
  PlanWidgetRole["ImageContainer"] = "imageContainer";
  PlanWidgetRole["PlanName"] = "planName";
  PlanWidgetRole["PlanNameContainer"] = "planNameContainer";
  PlanWidgetRole["RibbonWidget"] = "ribbon1";
  PlanWidgetRole["RibbonContainer"] = "ribbonContainer";
  PlanWidgetRole["RibbonText"] = "ribbonText";
  PlanWidgetRole["PricingWidget"] = "currencyPosition1";
  PlanWidgetRole["Description"] = "planDescription";
  PlanWidgetRole["DescriptionContainer"] = "planDescriptionContainer";
  PlanWidgetRole["PlanDuration"] = "planDuration";
  PlanWidgetRole["Button"] = "ctaButton";
  PlanWidgetRole["ContentDividerHorizontal"] = "horizontalContentDivider";
  PlanWidgetRole["ContentDividerVertical"] = "contentDivider";
  PlanWidgetRole["ContentDividerContainer"] = "contentDividerContainer";
  PlanWidgetRole["EmptyStateTitle"] = "emptyStateTitle";
  PlanWidgetRole["EmptyStateText"] = "emptyStateText";
  PlanWidgetRole["PerksWidget"] = "benefits1";
  PlanWidgetRole["PlanWidget"] = "singlePlan1";
  PlanWidgetRole["PlanInnerContainer"] = "box2";
  PlanWidgetRole["PlanContainer"] = "singlePlanContainer";
  return PlanWidgetRole;
}({});
export let PricingWidgetRole = /*#__PURE__*/function (PricingWidgetRole) {
  PricingWidgetRole["Price"] = "price";
  PricingWidgetRole["Frequency"] = "frequency";
  PricingWidgetRole["Currency"] = "currency";
  PricingWidgetRole["SetupFee"] = "setupFee";
  return PricingWidgetRole;
}({});
export let PerksWidgetRole = /*#__PURE__*/function (PerksWidgetRole) {
  PerksWidgetRole["PerksContainer"] = "perksContainer";
  PerksWidgetRole["PerkItem"] = "perk";
  PerksWidgetRole["PerkContent"] = "perkContent";
  PerksWidgetRole["PerkText"] = "perkText";
  PerksWidgetRole["PerkIcon"] = "perkIcon";
  PerksWidgetRole["PerkDivider"] = "perkDivider";
  return PerksWidgetRole;
}({});
//# sourceMappingURL=roles.js.map